export enum DashboardSectionType {
    ee = 'employementEquity',
    wsp = 'wsp'
}